var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.074,
    height: 116.968,
    viewBox: "0 0 227.074 116.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534",
    transform: "translate(-3451 1600.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530",
    transform: "translate(3451 -1600.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12472",
    "data-name": "Path 12472",
    d: "M3848.894-1455.252h-13.429a11.467,11.467,0,0,0-11.433,11.433h0a11.467,11.467,0,0,0,11.433,11.433h13.429a11.467,11.467,0,0,0,11.433-11.433h0A11.467,11.467,0,0,0,3848.894-1455.252Z",
    transform: "translate(-3633.253 1529.461)",
    fill: "#f6f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12473",
    "data-name": "Path 12473",
    d: "M3487.295-1554.693a11.467,11.467,0,0,0-11.433-11.433h-13.429A11.467,11.467,0,0,0,3451-1554.693a11.467,11.467,0,0,0,11.433,11.433h13.429A11.467,11.467,0,0,0,3487.295-1554.693Z",
    transform: "translate(-3451 1583.631)",
    fill: "#f6f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12474",
    "data-name": "Path 12474",
    d: "M3652.944-1539.972a11.466,11.466,0,0,0,11.432-11.433h0a11.466,11.466,0,0,0-11.432-11.433h-21.167c-5.3-21.486-26.033-37.516-50.806-37.516a53.691,53.691,0,0,0-40.139,17.505h-17.511a11.467,11.467,0,0,0-11.433,11.433,11.466,11.466,0,0,0,11.433,11.433h4.05a53.779,53.779,0,0,0-4.737,18.545h-22.493A11.466,11.466,0,0,0,3488.709-1530h0a11.466,11.466,0,0,0,11.433,11.433h25.75a54.125,54.125,0,0,0,50.7,35.185,54,54,0,0,0,41.915-19.893h20.823a11.466,11.466,0,0,0,11.433-11.433h0a11.466,11.466,0,0,0-11.433-11.433h-9.827a54.294,54.294,0,0,0,1.2-11.349v-.021c.273-.809.517-1.63.746-2.457Z",
    transform: "translate(-3469.424 1600.354)",
    fill: "#f6f5fa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3309",
    "data-name": "Rectangle 3309",
    width: 50.527,
    height: 3.581,
    transform: "translate(3535.096 -1521.182)",
    fill: "#e5e5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1062",
    "data-name": "Ellipse 1062",
    cx: 2.728,
    cy: 2.728,
    r: 2.728,
    transform: "translate(3497.698 -1534.197)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1063",
    "data-name": "Ellipse 1063",
    cx: 1.112,
    cy: 1.112,
    r: 1.112,
    transform: "translate(3559.049 -1525.441)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1064",
    "data-name": "Ellipse 1064",
    cx: 2.728,
    cy: 2.728,
    r: 2.728,
    transform: "translate(3606.368 -1557.784)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531",
    transform: "translate(3508.441 -1574.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12475",
    "data-name": "Path 12475",
    d: "M3566.895-1541.85a3.584,3.584,0,0,1-3.581-3.58,3.585,3.585,0,0,1,3.581-3.581,3.585,3.585,0,0,1,3.581,3.581A3.584,3.584,0,0,1,3566.895-1541.85Zm0-6.366a2.789,2.789,0,0,0-2.785,2.785,2.788,2.788,0,0,0,2.785,2.785,2.788,2.788,0,0,0,2.785-2.785A2.788,2.788,0,0,0,3566.895-1548.216Z",
    transform: "translate(-3563.314 1549.011)",
    fill: "#5397db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532",
    transform: "translate(3533.107 -1572.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12476",
    "data-name": "Path 12476",
    d: "M3665.538-1496.222l-5.2-10.391a1.073,1.073,0,0,0-.964-.6h-41.562a1.074,1.074,0,0,0-.964.6l-5.195,10.39a1.082,1.082,0,0,0-.114.482v24.759a1.08,1.08,0,0,0,1.078,1.078h51.952a1.079,1.079,0,0,0,1.078-1.078v-24.759A1.085,1.085,0,0,0,3665.538-1496.222Zm-47.054-8.831h40.229l4.118,8.235h-13.842a1.079,1.079,0,0,0-1.078,1.078,9.323,9.323,0,0,1-9.312,9.313,9.324,9.324,0,0,1-9.313-9.313,1.079,1.079,0,0,0-1.077-1.078h-13.842Zm45.012,32.994h-49.8v-22.6h13.47l.063.467a11.505,11.505,0,0,0,11.365,9.924,11.5,11.5,0,0,0,11.364-9.924l.063-.466h13.47Z",
    transform: "translate(-3611.544 1527.465)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12477",
    "data-name": "Path 12477",
    d: "M3663.475-1532.912a1.392,1.392,0,0,0,1.393-1.393v-11.118a1.392,1.392,0,0,0-1.393-1.392,1.392,1.392,0,0,0-1.392,1.392v11.118A1.392,1.392,0,0,0,3663.475-1532.912Z",
    transform: "translate(-3636.236 1546.815)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12478",
    "data-name": "Path 12478",
    d: "M3690.3-1525.656a1.387,1.387,0,0,0,.861.3,1.39,1.39,0,0,0,1.094-.531l6.883-8.731a1.392,1.392,0,0,0-.232-1.956,1.392,1.392,0,0,0-1.956.232l-6.883,8.732A1.392,1.392,0,0,0,3690.3-1525.656Z",
    transform: "translate(-3649.765 1541.958)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12479",
    "data-name": "Path 12479",
    d: "M3624.622-1525.784a1.391,1.391,0,0,0,.985.407,1.39,1.39,0,0,0,.985-.407,1.392,1.392,0,0,0,0-1.969l-7.862-7.862a1.392,1.392,0,0,0-1.969,0,1.392,1.392,0,0,0,0,1.969Z",
    transform: "translate(-3613.893 1541.542)",
    fill: "#a4a2af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533",
    transform: "translate(3590.118 -1577.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12480",
    "data-name": "Path 12480",
    d: "M3728.362-1545.221l-1.583-3.761-3.761-1.583,3.761-1.583,1.583-3.762,1.583,3.762,3.762,1.583-3.762,1.583Zm-3.144-5.344,2.213.931.931,2.213.931-2.213,2.213-.931-2.213-.931-.931-2.213-.931,2.213Z",
    transform: "translate(-3723.018 1555.91)",
    fill: "#5397db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12481",
    "data-name": "Path 12481",
    d: "M3640.444-1461.78a.643.643,0,0,0-.253-.164l-3.791-2a.644.644,0,0,0-.87.268.644.644,0,0,0,.269.87l2.743,1.45-2.72,1.3a.644.644,0,0,0-.3.859.644.644,0,0,0,.582.366.643.643,0,0,0,.278-.063l3.731-1.786a.643.643,0,0,0,.463-.333A.643.643,0,0,0,3640.444-1461.78Z",
    transform: "translate(-90.119 -66.608)",
    fill: "#a4a2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12482",
    "data-name": "Path 12482",
    d: "M3681.307-1461.78a.65.65,0,0,1,.253-.164l3.791-2a.644.644,0,0,1,.87.268.644.644,0,0,1-.268.87l-2.743,1.45,2.72,1.3a.644.644,0,0,1,.3.859.645.645,0,0,1-.582.366.643.643,0,0,1-.278-.063l-3.731-1.786a.643.643,0,0,1-.463-.333A.643.643,0,0,1,3681.307-1461.78Z",
    transform: "translate(-112.423 -66.608)",
    fill: "#a4a2af"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.0ec64d21fe68a7bd6c9709d720183734.svg";
export { ForwardRef as ReactComponent };